<template>
<BootstrapDialog title="课件学习进度统计详情" ref="dialog" size="lg" @afterClose="afterClose()" :modal-style="{'width':'1100px'}">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		    <div class="row">
		        <div class="col-sm-12">
		            <BootstrapTable style="font-size: 14px;"
		                            ref="table"
		                            v-once
		                            :columns="columns"
		                            :options="{
											classes:'table table-hover',
		                                	undefinedText:'',
		                                    showColumns: false,
		                                    sidePagination:'server',
		                                    pagination:true,
		                                    pageNumber:1,
		                                    pageSize:10,
		                                    pageList:[10,50,100,500],
		                                    paginationPreText:'上一页',
		                                    paginationNextText:'下一页',
		                                    showExtendedPagination:true,
		                                    paginationLoop:false
		                                }"
		                            @onPostBody="vueFormatterPostBody"
		                            @onPageChange="pageChange"
		            />
		        </div>
		    </div>
		</div>
	</template>
	<template v-slot:footer>
			<button class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>

    /**
     * 学习进度统计 --查看詳情
     */
    import tableMixin from '@/mixins/table.js';
    export default {
        mixins: [tableMixin],
        name:'KjxxLearningProgressDetail',
        components:{
        },
        data:function(){
            return {
                query:{
                    xmId:'',
                    dwId:''
                },
                columns: [
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index) => {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
					{
					    field: 'pxzt',
					    title: '报考专业',
						formatter: (value, row) => {
							return value + '<br>(编号：' + row.xmbh+')';
						}
					},
                    {
                        field: 'kcmc',
                        title: '课程'
                    },
                    // {
                    //     field: 'jgmc',
                    //     title: '学员单位',
                    //     formatter: (value, row) => {
                    //         return row.jgdm+"-"+row.jgmc;
                    //     }
                    // },
				  {
						  field: 'zbmkc',
						  title: '总报名科次'
				  },
                  {
                      field: 'zxxjd',
                      title: '总学习进度（百分比）',
					  formatter: (value, row, index) => {
					      return  value +"%";
					  }
                  },
                  {
                      field: 'yxxrs',
                      title: '已学习人数'
                  },
                  {
                      field: 'xxjd',
                      title: '学习进度（百分比）',
					  formatter: (value, row, index) => {
					      return  value +"%";
					  }
                  }
                ]
            }
        },
        methods:{
			reset:function(){
				this.query = {
				    xmId:'',
				    dwId:''
				};
			},
			async open(params){
				this.query.xmId = params.xmId;
				this.query.dwId = params.dwId;
				this.query.current = 1;
				this.query.size = 10;
				let res =await this.$http.post('/htgl/biz/zypx/kjxx/jdtj/xq', this.query);
				if(res.data){
					let data = res.data;
					//封装返回值
					let result = {
					    total: data.total,
					    rows: data.records
					};
					//table加载返回的数据
					this.$refs.table.load(result);
				}
				this.$refs.dialog.open();
			},
			afterOpen:function(){
				this.load(1, 10);
			},
			close:function(){
				this.$refs.dialog.close();
			},
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			},
			// 返回表格数据
			load: function (pageNumber, pageSize) {
               this.query.current = pageNumber || this.query.current;
               this.query.size = pageSize || this.query.size;
               this.$http.post('/htgl/biz/zypx/kjxx/jdtj/xq', this.query).then(res => {
                   let data = res.data;
                   //封装返回值
                   let result = {
                       total: data.total,
                       rows: data.records
                   };
                   //table加载返回的数据
                   this.$refs.table.load(result);
               });
			},
			pageChange: function (pageNumber, pageSize) {
               this.load(pageNumber, pageSize);
			}
        }

    }
</script>
